import React from 'react';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <main className="contact-page">
      <section className="contact-hero">
        <h1>Maak een afspraak.</h1>
        <p>
          Als interim Agile professional help ik organisaties met het implementeren van werkende Agile oplossingen. 
          Focus op eindgebruikers, transparante stakeholdercommunicatie en praktische documentatie voor blijvend resultaat. 
          Wil je weten wat ik voor je kan betekenen?
        </p>
      </section>

      <section className="contact-section">
        <div className="contact-wrapper">
          <div className="timeline">
            <div className="dot"></div>
            <div className="line"></div>
          </div>
          <div className="contact-content">
            <h2>Hoe bereik je mij?</h2>
            <h3>Telefoon of e-mail</h3>
            <p>
            Zullen we eens kennismaken? Je kunt me bereiken via telefoon, e-mail of WhatsApp voor een reactie binnen één werkdag.
Liever dat ik jou bel? Vul dan het contactformulier in met je voorkeursmoment, dan neem ik contact met je op.
Ik kijk ernaar uit om je te helpen!            
</p>

            {/* Direct Contact Information */}
            <div className="contact-info">
              <h3>Direct contact</h3>
              <p>+31 (0)6 23990856</p>
              <a href="mailto:jesse@corevisionconsultancy.nl">jesse@corevisionconsultancy.nl</a>
            </div>
            
            {/* Contact Form */}
            <div className="mt-8">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;